import axios from 'axios';
import $ from 'jquery';

const PortalNew = () => {
  if (!window.route || !/^portal\//.test(window.route)) {
    return;
  }

  const $body = $('body');
  $body
    .delegate('.enquiry-action', 'click', function (e) {
      e.preventDefault();
      axios
        .post(this.href)
        .then(() => {
          const $enquiryElement = $(this).closest('.enquiry-item');

          // Is it a list page AND there are more enquiries?
          if ($enquiryElement.closest('.enquiries-list').length && $enquiryElement.siblings('.enquiry-item').length > 0) {
            $enquiryElement.remove();
          } else {
            window.location.reload();
          }
        })
        // eslint-disable-next-line no-alert
        .catch(({ response: res }) => alert(res.data && res.data.message
          ? res.data.message
          : 'Something went terribly wrong, try reload the page...'
        ));
    });
};

export default PortalNew;



// WEBPACK FOOTER //
// ./portal-new/scripts/main.js